import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import App from './App.vue'
import AppGov from './AppGov.vue'
import router from './router'
import store from './store'
import constant from './enums/constant'
import ssoWeb from './lib/SSO'
import DynamicComponent from '@era/edc-vue'
import http from './lib/http'
import axios from './lib/axios'
import qs from 'qs'
import * as utils from '@bike/fe-utils'
import * as snapdom from '@zumer/snapdom'
import VueAMap from 'vue-amap'
import { addOwlError, addOwlInfo, addOwlWarn, addOwlDebug } from '@bike/fe-owl'
import './components'
import './plugins/fetch'
import './plugins/mtd'
import './plugins/elementui'
import './plugins/bike-components'
import './lib/global-router-guards'
import 'normalize.css/normalize.css'
import './assets/styles/main.scss'
import './assets/styles/editor.scss'
import './assets/styles/mtd-diy.scss'
import { dateFormat } from '@/utils'
import LXAnalytics from '@/mixins/lx'
// 注入全局变量
window.__BIKE_POLARIS__ = {
  ssoWeb,
  http,
  qs,
  LXAnalytics,
  snapdom,
  platform: 'associate', // 用于EDC组件内判断平台
  // userName mis uid 会在 HeaderUser.vue 中覆盖
  userName: '',
  mis: '',
  ssoid: '',
  // owl
  addOwlError,
  addOwlInfo,
  addOwlWarn,
  addOwlDebug,
}

Vue.config.errorHandler = (err, vm, info) => {
  console.error('[global]', err)
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
  return addOwlError({
    name: `[global] ${err.message}`,
    msg: {
      info,
      stack: err.stack,
    },
  })
}

const EDCRegistry = window.__EDC__
const { VUE_APP_EDC_ENV: edcEnv } = process.env
EDCRegistry.config({
  env: edcEnv, // 标记当前项目运行的环境，如 test, staging, production，会影响【我的项目-xx项目-xx组件】中配置的组件下发策略
  projectId: 'com.sankuai.bike.web.epartner',
  dev: edcEnv === 'dev',
  // registry: '' // 一般情况用不到；可指定组件的配置请求地址
  // devRegistry: `http://127.0.0.1:8848/__edc__/api` // 本地调试时使用 for edc cli
  // extendEnvKeys: { },// 自定义环境信息，可用于灰度时的自定义环境参数
})
Vue.use(DynamicComponent)
EDCRegistry.addService('Vue', Vue)
EDCRegistry.addService('Vuex', Vuex)
EDCRegistry.addService('Router', Router)
EDCRegistry.addService('http', http)
EDCRegistry.addService('utils', utils)

Vue.config.productionTip = false

VueAMap.initAMapApiLoader({
  v: '1.5.2', // 高德地图JSAPI适配器版本
  key: 'mcb7134a97f34c54940b39985690b7ej', // 美团地图KEY值
  // debug: true, // debug=true 打开调试模式，浏览器console中可查看美团地图适配的高德地图有哪些参数、控件不支持
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar'],
  // uiVersion: '1.0.11', // 美团适配不支持
  hostAndPath: 'lbsapi.meituan.com/jsapi/adapter/amap', // 高德地图JSAPI适配器
})
Vue.use(VueAMap)
// 调试vue
Vue.prototype.$debugVue = (name, vm) => {
  if (process.env.NODE_ENV === 'development') {
    window[name] = vm
  }
}
// 使用频率高的方法
Vue.prototype.associateUtils = {
  dateFormat,
}
Vue.prototype.$addOwlError = addOwlError

// 按钮权限控制
Vue.directive('auth', {
  // bind: function () {},
  bind: function(el, binding, vnode) {
    const auths = vnode.context.$store.state.uacApiAuth
    Vue.nextTick(function() {
      if (binding.value && !auths.includes(binding.value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    })
  },
})

ssoWeb.login().then(ssoid => {
  if (ssoid && typeof ssoid === 'string') {
    // api请求头部添加x-requested-with:XMLHttpRequest
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    // 推荐将ssoid放到access-token, 后端SDK优先读取它
    axios.defaults.headers.common['access-token'] = ssoid
    window.__BIKE_POLARIS__.ssoid = ssoid
    new Vue({
      router,
      store,
      const: constant,
      render: h => h(location.search.indexOf('utm_source=g') > -1 ? AppGov : App),
    }).$mount('#app')
  }
})
